import http from "../http-common";
import { INotificationResponseData } from "../types/Notification";

const getMeNotification = (isRead?: boolean, page: number = 0, size: number = 10, sort: string = "createdAt,desc") => {
  return http.get<INotificationResponseData[]>(`/users/me/notifications`, {
    params: {
      isRead: isRead,
      page: page,
      size: size,
      sort: sort,
    },
  });
};

const readNotification = (id: number) => {
  return http.put<INotificationResponseData>(`/notifications/${id}/read`);
};

const getAllNotifications = () => {
  return http.get<INotificationResponseData[]>(`/notifications`);
};

const getNotificationById = (id: number) => {
  return http.get<INotificationResponseData>(`/notifications/${id}`);
};

const completeNotification = (id: number) => {
  return http.post<void>(`/notifications/${id}/complete`);
};

const postNotificationsMasTeamForManager = (filteredData: any) => {
  return http.post<any>(`/notifications/mas-team/filter/manager${filteredData}`);
}

const postNotificationsMasTeamForMember = (filteredData: any) => {
  return http.post<any>(`/notifications/mas-team/filter/member${filteredData}`);
}

const NotificationService = {
  getMeNotification,
  readNotification,
  getAllNotifications,
  getNotificationById,
  completeNotification,
  postNotificationsMasTeamForManager,
  postNotificationsMasTeamForMember
};

export default NotificationService;
